import { getApi, postApi } from "./helpers/apiMethods";
import {
  ArchieNewChatRequest,
  ArchieContinueChatRequest,
  ArchieChatResponse,
  ArchieConversationListResponse,
  ArchieConversationMessagesResponse,
} from "../types/archie/archie";

export const startArchieChat = async (
  request: ArchieNewChatRequest
): Promise<ArchieChatResponse> => {
  const response = await postApi<ArchieChatResponse, ArchieNewChatRequest>(
    "/v1/ai/chat",
    request
  );
  return response.data!;
};

export const continueArchieChat = async (
  conversationId: string,
  request: ArchieContinueChatRequest
): Promise<ArchieChatResponse> => {
  const response = await postApi<
    ArchieChatResponse,
    ArchieContinueChatRequest
  >(`/v1/ai/chat/${conversationId}`, request);
  return response.data!;
};

export const listArchieConversations = async (
  customerId: string
): Promise<ArchieConversationListResponse> => {
  const response = await getApi<ArchieConversationListResponse>(
    `/v1/ai/chat/conversations?customerId=${customerId}`
  );
  return response.data!;
};

export const getArchieConversationMessages = async (
  conversationId: string
): Promise<ArchieConversationMessagesResponse> => {
  const response = await getApi<ArchieConversationMessagesResponse>(
    `/v1/ai/chat/${conversationId}/messages`
  );
  return response.data!;
};
